// extracted by mini-css-extract-plugin
export default {"form":"form_form__6MLiU","modal":"form_modal__NWcx5","narrow":"form_narrow__ktZlG","wide":"form_wide__dHFxb","noGap":"form_noGap__xO36T"};